var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSandGlass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 1H2c-.6 0-1 .4-1 1v2.4c0 .4.1.8.4 1.2L4.6 10l-3.2 4.4c-.2.3-.4.8-.4 1.2V18c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-2.3c0-.4-.1-.9-.4-1.2l-3.4-4.4 3.4-4.4c.3-.4.4-.8.4-1.2V2.2c0-.7-.5-1.2-1-1.2Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSandGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sand-glass.a6675f09fa84f2b7546f9ce634071448.svg";